import { ArrowRightIcon } from 'lucide-react'

interface WelcomeChoiceCardProps {
  imageSrc: string
  title: string
  description: string
  onChoose: () => void
}

export function WelcomeChoiceCard({
  imageSrc,
  title,
  description,
  onChoose,
}: WelcomeChoiceCardProps) {
  return (
    <button
      type="button"
      onClick={onChoose}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border bg-white text-left transition hover:border-brand hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
    >
      <div className="bg-background px-4 pt-4">
        <img
          src={imageSrc}
          alt=""
          className="aspect-[2/1] w-full object-cover object-left-top"
        />
      </div>
      <div className="space-y-1 p-4">
        <p className="flex items-center gap-1.5 font-semibold text-blue-7">
          {title}
          <ArrowRightIcon className="size-4 transition group-hover:translate-x-0.5" />
        </p>
        <p className="text-pretty text-sm text-blue-6">{description}</p>
      </div>
    </button>
  )
}
